'use es6';

import UIAlert from 'UIComponents/alert/UIAlert';
import H4 from 'UIComponents/elements/headings/H4';
import UIHelpLink from 'UIComponents/tooltip/UIHelpLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const trackTooltipInteraction = (evt, isUserJitad) => {
  if (evt.target.value && !isUserJitad) {
    UsageTracker.trackEditorInteraction({
      action: 'Approvals Action',
      event: 'viewContentEditorAccessRequestTooltip'
    });
  }
};
const ReadOnlyTestVariantWarning = ({
  className,
  isAbTest,
  isMabTest,
  isUserJitad
}) => {
  let langSubkey;
  if (isAbTest) {
    langSubkey = 'abTest';
  } else if (isMabTest) {
    langSubkey = 'mabTest';
  } else {
    throw new Error('ReadOnlyTestVariantWarning can only be rendered when isAbTest or isMabTest is true');
  }
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: "warning",
    className: className,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `readOnlyTestVariantWarning.${langSubkey}.title`
    }), /*#__PURE__*/_jsx(UIHelpLink, {
      defaultOpen: false,
      showCloseButton: true,
      className: "m-left-2",
      onOpenChange: evt => trackTooltipInteraction(evt, isUserJitad),
      content: {
        header: /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `readOnlyTestVariantWarning.${langSubkey}.helpPopoverHeader`
          })
        }),
        body: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `readOnlyTestVariantWarning.${langSubkey}.helpPopoverBody`
          })
        })
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `readOnlyTestVariantWarning.${langSubkey}.helpPopoverLink`
      })
    })]
  });
};
export default ReadOnlyTestVariantWarning;